$('input[name="ticket_type"]').change(function () {
    let additionalFieldsContainer = $('#additional-ticket-fields');
    console.log(this.value)
    switch (this.value) {
        case 'student':
            additionalFieldsContainer.find('> div').not('.student-number').slideUp();
            additionalFieldsContainer.find('input').val('');
            additionalFieldsContainer.slideDown()
            additionalFieldsContainer.find('.student-number').slideDown();
            break;
        case ['donator', 'club'].includes(this.value) ? this.value : null:
            additionalFieldsContainer.find('> div').not('.code').slideUp();
            additionalFieldsContainer.find('input').val('');
            additionalFieldsContainer.slideDown();
            additionalFieldsContainer.find('.code').slideDown();
            break;
        default:
            additionalFieldsContainer.slideUp();
            additionalFieldsContainer.find('input').val('');
            additionalFieldsContainer.find('> div').slideUp();
            break;
    }
});

